import { render } from "./AdminTranslationsBrowser.vue?vue&type=template&id=42775440&scoped=true"
import script from "./AdminTranslationsBrowser.vue?vue&type=script&lang=js"
export * from "./AdminTranslationsBrowser.vue?vue&type=script&lang=js"

import "./AdminTranslationsBrowser.vue?vue&type=style&index=0&id=42775440&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42775440"]])

export default __exports__